import React, { useState, useRef, useCallback } from 'react'
import { Dispatch } from 'redux'
import { CloudUploadOutlined } from '@material-ui/icons'
import { useDropzone } from 'react-dropzone'
import {
  IFile,
  SetPreviewFieldWrapperType,
  OnProgressCallbackType,
} from '../../types/file'
import {
  closeUploadDialog,
  readLocalFileForPreview,
  readLocalFileCancel,
  setProgress,
  uploadPreview,
} from '../../actions/file'
import { readUploadedFile } from '../../services/file'
import { StyledFileZone } from './styled'
import { P } from '../StyledText'
import UploadModal from '../UploadModal'

export interface IPreviewUploadZone {
  id: string
  file: IFile
  setPreviewFieldWrapper: SetPreviewFieldWrapperType
  dispatch: Dispatch
}

export const PreviewUploadZoneComponent = ({
  id,
  file,
  setPreviewFieldWrapper,
  dispatch,
}: IPreviewUploadZone) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [fileTemporaryURL, setFileTemporaryURL]: [
    string | null,
    any
  ] = useState(null)

  const withProgress: OnProgressCallbackType = (progress: number) => {
    dispatch(setProgress(progress))
  }

  const handleUploadPreview = (fileName: string): void => {
    if (fileTemporaryURL) {
      dispatch(
        uploadPreview(withProgress)(
          id,
          setPreviewFieldWrapper(fileTemporaryURL),
          fileName
        )
      )
    }
  }

  const handleClosePreviewModal = (): void => {
    setFileTemporaryURL(null)
    dispatch(closeUploadDialog())
  }

  const onDrop = useCallback(
    async ([fileInstance, ...otherFiles]: File[]) => {
      if (otherFiles.length !== 0) {
        dispatch(readLocalFileCancel('You can only upload one file at a time.'))
        return
      }
      dispatch(readLocalFileForPreview(id, fileInstance))
      const fileURL = await readUploadedFile(fileInstance, dispatch)
      setFileTemporaryURL(fileURL)
    },
    [dispatch, id, setFileTemporaryURL]
  )
  const { getRootProps, getInputProps } = useDropzone({ onDrop })
  return (
    <>
      <StyledFileZone {...getRootProps()} small>
        <section>
          <P>Drag and drop files here or click to browse</P>
          <CloudUploadOutlined />
        </section>
        <input {...getInputProps()} ref={inputRef} id={id} hidden />
      </StyledFileZone>
      <UploadModal
        open={file.openedModal === id}
        title="Upload file"
        actionLabel="Upload"
        action={handleUploadPreview}
        handleClose={handleClosePreviewModal}
        file={file}
        showThumbnail={file.mimetype.startsWith('image/')}
        fileTemporaryURL={fileTemporaryURL}
        onDrop={(e) => {
          dispatch(readLocalFileCancel('Only one image could be dropped.'))
        }}
      />
    </>
  )
}
